@import 'tailwindcss';
@import './components/FloatingSurfaceStandard.css';

@source '../../templates/**/*.html';

@theme {
  --bg: #f3f4f6;
  --bg-strong: #e9edf1;
  --panel: #ffffff;
  --panel-strong: #ffffff;
  --panel-soft: #f9fafb;
  --results-shell-main: #f3f4f6;
  --results-shell-outer: #fafbfc;
  --results-shell-periphery: #e8ecf1;
  --results-shell-nav: #e4e8ef;
  --line: #e5e7eb;
  --line-strong: #d1d5db;
  --text: #111827;
  --muted: #6b7280;
  --muted-strong: #4b5563;
  --color-brand: #0f5c57;
  --color-brand-dark: #0a4945;
  --color-brand-light: #ecfdf5;
  --color-legacy-teal: #0f5c57; /* NE PAS UTILISER - legacy seulement */
  --color-legacy-teal-strong: #0a423f;
  --color-legacy-teal-soft: #d7efea;
  --color-legacy-green: #16775d; /* NE PAS UTILISER - legacy seulement */
  --color-legacy-green-soft: #d8f2e7;
  --route-loading-rgb: 90, 121, 190;
  --route-loading: #5a79be;
  --route-loading-strong: #3f5585;
  --route-loading-soft: #e8eef9;
  --route-loading-ink: #31486f;
  --amber: #d08b3e;
  --amber-soft: #f4e1c6;
  --danger: #c5524a;
  --danger-soft: #f9e1de;
  --neutral-soft: #eef2f5;
  --grain-badge-bg: rgba(229, 238, 232, 0.96);
  --grain-badge-text: #3e5d50;
  --pill-success-fill: #b8dcbe;
  --pill-idle-fill: #dbe1e7;
  --pill-info-fill: #dce6e0;
  --report-status-success-fill: rgba(223, 243, 240, 0.9);
  --report-status-warning-fill: rgba(255, 247, 237, 0.94);
  --report-status-danger-fill: rgba(254, 242, 242, 0.94);
  --dashboard-metric-amber-fill: rgba(255, 248, 238, 0.92);
  --dashboard-metric-sage-fill: rgba(247, 250, 247, 0.88);
  --dashboard-metric-slate-fill: rgba(245, 249, 251, 0.9);
  --dashboard-metric-teal-fill: rgba(239, 249, 246, 0.9);
  --dashboard-metric-amber-border: rgba(191, 155, 94, 0.16);
  --dashboard-metric-sage-border: rgba(105, 136, 122, 0.14);
  --dashboard-metric-slate-border: rgba(115, 134, 145, 0.15);
  --dashboard-metric-teal-border: rgba(93, 141, 131, 0.15);
  --dashboard-panel-amber-border: rgba(171, 138, 85, 0.16);
  --dashboard-panel-sage-border: rgba(94, 112, 100, 0.13);
  --dashboard-panel-slate-border: rgba(104, 123, 132, 0.14);
  --dashboard-panel-teal-border: rgba(90, 132, 122, 0.15);
  --dashboard-panel-amber-surface: radial-gradient(circle at top left, rgba(255, 243, 224, 0.94), rgba(255, 249, 241, 0.96) 50%, rgba(255, 255, 255, 0.98) 100%);
  --dashboard-panel-sage-surface: radial-gradient(circle at top left, rgba(234, 242, 236, 0.92), rgba(255, 249, 239, 0.95) 48%, rgba(255, 255, 255, 0.98) 100%);
  --dashboard-panel-slate-surface: radial-gradient(circle at top left, rgba(233, 241, 245, 0.94), rgba(248, 251, 252, 0.96) 48%, rgba(255, 255, 255, 0.98) 100%);
  --dashboard-panel-teal-surface: radial-gradient(circle at top left, rgba(227, 243, 240, 0.94), rgba(246, 250, 248, 0.96) 50%, rgba(255, 255, 255, 0.98) 100%);
  --badge-black-border: rgba(0, 0, 0, 0.26);
  --badge-black-border-strong: rgba(0, 0, 0, 0.52);
  --crop-default-bg: #f4f6fb;
  --crop-default-text: #56657d;
  --crop-default-border: #d6dfec;
  --crop-mais-bg: #eef2ff;
  --crop-mais-text: #3730a3;
  --crop-mais-border: #c7d2fe;
  --crop-ble-bg: #f6efe8;
  --crop-ble-text: #7a5b3f;
  --crop-ble-border: #e4d4c1;
  --crop-soya-bg: #e6f7fb;
  --crop-soya-text: #0f6f8c;
  --crop-soya-border: #bde4ee;
  --crop-orge-bg: #edf3f8;
  --crop-orge-text: #45627a;
  --crop-orge-border: #d1deea;
  --crop-avoine-bg: #f3efff;
  --crop-avoine-text: #6b4fc3;
  --crop-avoine-border: #ddd1ff;
  --crop-canola-bg: #fdebf3;
  --crop-canola-text: #a13b67;
  --crop-canola-border: #f5ccdc;
  --route-delivery-rgb: 150, 138, 62;
  --route-delivery: #968a3e;
  --route-delivery-strong: #70672e;
  --route-delivery-soft: #f4efdb;
  --shadow: 0 18px 38px rgba(15, 23, 42, 0.08), 0 4px 10px rgba(15, 23, 42, 0.04);
  --shadow-soft: 0 10px 24px rgba(15, 23, 42, 0.06), 0 2px 6px rgba(15, 23, 42, 0.03);
  --radius-2xl: 30px;
  --radius-xl: 24px;
  --radius-lg: 18px;
  --radius-md: 14px;
  --radius-sm: 10px;
  --radius-overlay: 12px;
  --content-width: 1640px;

  --color-bg: var(--bg);
  --color-bg-strong: var(--bg-strong);
  --color-panel: var(--panel);
  --color-panel-strong: var(--panel-strong);
  --color-panel-soft: var(--panel-soft);
  --color-line: var(--line);
  --color-line-strong: var(--line-strong);
  --color-text: var(--text);
  --color-muted: var(--muted);
  --color-muted-strong: var(--muted-strong);
  --color-accent: var(--color-brand);
  --color-accent-strong: var(--color-brand-dark);
  --color-accent-soft: var(--color-brand-light);
  --color-success: var(--color-legacy-green);
  --color-success-soft: var(--color-legacy-green-soft);
  --color-success-ink: #22472f;
  --color-danger: var(--danger);
  --color-danger-soft: var(--danger-soft);
  --color-amber: var(--amber);
  --color-amber-soft: var(--amber-soft);
  --color-warning-ink: #9a5b12;
  --color-neutral-soft: var(--neutral-soft);
  --color-surface: #ffffff;
  --color-surface-soft: #ffffff;
  --color-surface-muted: #f9fafb;
  --color-line-soft: #e5e7eb;
  --hovercard-accent-success: rgba(34, 109, 90, 0.82);
  --hovercard-accent-danger: rgba(185, 28, 28, 0.82);
  --hovercard-accent-warning: rgba(180, 83, 9, 0.84);
  --hovercard-accent-neutral: rgba(65, 84, 90, 0.82);
  --hovercard-accent-info: rgba(59, 100, 165, 0.82);
  --color-border-card: rgba(71, 85, 105, 0.24);
  --color-border-card-hover: rgba(71, 85, 105, 0.28);
  --color-progress-over: #ef4444;
  --color-progress-warn: #d97706;
  --color-progress-disabled: #cbd5e1;
  --color-floating-ink-strong: #111827;
  --color-floating-ink: #1a1f2e;
  --color-floating-copy: #4b5563;
  --color-floating-muted: #6b7280;
  --color-floating-faint: #9ca3af;
  --color-content-ink: #1a1f2e;
  --color-content-copy: #4b5563;
  --color-content-muted: #6b7280;
  --color-content-faint: #9ca3af;
  --color-border-shell-subtle: #e5e7eb;
  --color-border-shell-strong: #d1d5db;
  --color-border-results-shell-subtle: #e5e7eb;
  --color-border-results-shell-strong: #d1d5db;
  --color-border-results-frame: #d1d5db;
  --color-border-neutral-subtle: rgba(96, 117, 115, 0.12);
  --color-border-accent-subtle: rgba(15, 92, 87, 0.12);
  --color-border-accent-muted: rgba(15, 92, 87, 0.18);
  --color-border-accent-strong: rgba(15, 92, 87, 0.22);
  --color-border-header-success: rgba(74, 130, 92, 0.22);
  --color-border-header-warning: rgba(187, 153, 92, 0.24);
  --color-border-header-danger: rgba(192, 116, 108, 0.22);
  --color-border-header-info: rgba(128, 148, 160, 0.22);
  --color-border-header-neutral: rgba(164, 172, 167, 0.22);
  --color-border-warning-subtle: rgba(208, 139, 62, 0.14);
  --color-border-warning-muted: rgba(208, 139, 62, 0.16);
  --color-border-warning-strong: rgba(208, 139, 62, 0.24);
  --color-border-warning-badge: rgba(217, 119, 6, 0.16);
  --color-border-danger-subtle: rgba(197, 82, 74, 0.14);
  --color-border-danger-muted: rgba(197, 82, 74, 0.18);
  --color-border-danger-strong: rgba(197, 82, 74, 0.3);
  --color-border-danger-badge: rgba(161, 74, 74, 0.18);
  --color-border-icon-shell: rgba(203, 213, 225, 0.82);
  --color-border-badge-subtle: rgba(0, 0, 0, 0.26);
  --color-border-badge-strong: rgba(0, 0, 0, 0.34);
  --color-border-metric-neutral: rgba(0, 0, 0, 0.14);
  --color-border-idle-subtle: rgba(86, 98, 111, 0.26);
  --color-border-success-strong: rgba(28, 70, 39, 0.34);
  --color-border-success-soft: rgba(22, 119, 93, 0.14);
  --color-border-primary-strong: rgba(0, 0, 0, 0.38);
  --color-border-optimize-subtle: rgba(51, 65, 85, 0.34);
  --color-border-optimize-strong: rgba(51, 65, 85, 0.42);
  --color-border-icon-subtle: rgba(15, 37, 36, 0.1);
  --color-border-success-subtle: rgba(47, 127, 72, 0.2);
  --color-border-success-muted: rgba(47, 127, 72, 0.28);
  --color-border-success-active: rgba(24, 82, 44, 0.34);
  --color-border-blocked-subtle: rgba(111, 149, 207, 0.34);
  --color-border-reassign-subtle: rgba(66, 85, 58, 0.18);
  --color-border-reassign-active: rgba(106, 87, 34, 0.32);
  --color-border-manual-subtle: rgba(161, 93, 20, 0.22);
  --color-border-warning-emphasis: rgba(180, 83, 9, 0.2);
  --color-surface-icon-shell: rgba(243, 244, 246, 0.96);
  --color-surface-accent-tint: rgba(15, 92, 87, 0.1);
  --color-surface-accent-tint-soft: rgba(15, 92, 87, 0.08);
  --color-surface-warning-badge: rgba(254, 243, 199, 0.9);
  --color-surface-danger-badge: rgba(165, 72, 72, 0.9);
  --color-surface-reassign: rgba(248, 249, 250, 0.97);
  --color-surface-empty-subtle: rgba(248, 249, 250, 0.9);
  --color-blocked-ink: rgba(80, 105, 141, 0.82);
  --color-status-warning-ink: #935717;
  --color-status-manual-ink: #6f3d06;
  --color-pill-idle-ink: #32414d;
  --color-pill-info-ink: #31463c;
  --color-button-primary-ink: #f4f7fa;
  --color-button-optimize-ink: #f8fafc;
  --color-button-reassign-ink: #42553a;
  --color-button-reassign-active-ink: #6f4a08;
  --color-shell-action-soft-ink: #295338;
  --color-shell-action-soft-ink-hover: #1f3f2b;
  --color-shell-subnav-active-border: rgba(148, 163, 184, 0.18);
  --color-shell-focus-ring: rgba(148, 163, 184, 0.24);
  --color-shell-group-open-border: rgba(148, 163, 184, 0.14);
  --color-shell-group-open-surface: rgba(255, 255, 255, 0.62);
  --color-shell-group-open-toggle-surface: rgba(148, 163, 184, 0.14);
  --color-shell-group-open-toggle-ink: #64748b;
  --color-shell-header-accent-rail: rgba(148, 163, 184, 0.48);
  --color-shell-header-accent-rail-strong: rgba(148, 163, 184, 0.58);
  --color-shell-header-accent-dot: rgba(186, 193, 203, 0.72);
  --color-shell-header-accent-dot-strong: rgba(186, 193, 203, 0.82);
  --color-shell-status-danger-ink: #9f3129;
  --color-shell-status-warning-ink: #946a18;
  --color-shell-status-success-ink: #295338;
  --color-shell-status-warning-dot: #c8972c;
  --color-shell-notice-running-border: rgba(120, 134, 149, 0.32);
  --color-shell-notice-success-border: rgba(92, 148, 104, 0.34);
  --color-shell-notice-danger-border: rgba(197, 82, 74, 0.28);
  --color-shell-notice-running-icon-border: rgba(120, 134, 149, 0.26);
  --color-shell-notice-success-icon-border: rgba(92, 148, 104, 0.24);
  --color-shell-notice-danger-icon-border: rgba(197, 82, 74, 0.22);
  --color-shell-notice-running-pill-border: rgba(120, 134, 149, 0.24);
  --color-shell-notice-success-pill-border: rgba(92, 148, 104, 0.24);
  --color-shell-notice-danger-pill-border: rgba(197, 82, 74, 0.2);
  --color-shell-notice-success-ink: #2f6b3e;
  --color-shell-notice-danger-ink: #b24339;
  /* Notice fills: historical Tailwind red-50 / green-50 / amber-50 at 0%. */
  --shell-notice-danger-fill: #fef2f2;
  --shell-notice-success-fill: #f0fdf4;
  --shell-notice-warning-fill: #fffbeb;
  --color-shell-topbar-default-border: rgba(203, 213, 225, 0.72);
  --color-shell-sidebar-nav-results-border: rgba(203, 213, 225, 0.82);
  --color-shell-sidebar-nav-default-border: rgba(203, 213, 225, 0.72);
  --color-shell-sidebar-default-border: rgba(203, 213, 225, 0.78);
  --color-shell-identity-panel-results-border: rgba(203, 213, 225, 0.68);
  --color-shell-identity-panel-default-border: rgba(203, 213, 225, 0.64);
  --color-shell-identity-logo-results-border: rgba(203, 213, 225, 0.64);
  --color-shell-identity-logo-default-border: rgba(203, 213, 225, 0.56);
  --color-shell-identity-logo-default-surface: rgba(255, 255, 255, 0.62);
  --color-shell-eyebrow: rgba(71, 85, 105, 0.78);
  --color-page-loading-overlay-scrim: rgba(8, 24, 28, 0.32);
  --color-page-loading-ring: rgba(15, 92, 87, 0.14);
  --color-page-loading-ring-strong: rgba(15, 92, 87, 0.34);
  --gradient-page-loading-shell:
    linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(240, 248, 246, 0.98)),
    radial-gradient(circle at top right, rgba(15, 92, 87, 0.16), transparent 34%),
    radial-gradient(circle at bottom left, rgba(208, 139, 62, 0.12), transparent 28%);
  --gradient-page-loading-shell-sheen: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.34),
    transparent 38%,
    rgba(15, 92, 87, 0.06) 100%
  );
  --gradient-page-loading-dot: linear-gradient(
    180deg,
    var(--color-legacy-teal),
    var(--color-legacy-teal-strong)
  );
  --shadow-page-loading-spinner: inset 0 1px 0 rgba(255, 255, 255, 0.7);
  --shadow-page-loading-meta: inset 0 1px 0 rgba(255, 255, 255, 0.82);
  --shadow-page-loading-dot: 0 10px 20px rgba(15, 92, 87, 0.18);
  --color-alert-warning-ink: #8a4f08;
  --color-kpi-accent: #2e6b54;
  --color-kpi-accent-strong: #21473f;
  --gradient-right-panel-surface-default:
    linear-gradient(180deg, rgba(248, 249, 250, 0.96), rgba(236, 238, 242, 0.94)),
    radial-gradient(circle at top right, rgba(255, 255, 255, 0.22), transparent 30%);
  --gradient-shell-results-brand-mark: linear-gradient(180deg, #21473f, #16352f);
  --shadow-right-panel-surface-default:
    inset 1px 0 0 rgba(255, 255, 255, 0.48), 0 0 0 1px rgba(148, 163, 184, 0.08);
  --shadow-shell-subnav-active: 0 10px 18px rgba(100, 116, 139, 0.08);
  --shadow-shell-results-brand-mark: 0 10px 16px rgba(27, 62, 53, 0.18);

  --radius-panel: var(--radius-md);

  --shadow-panel: var(--shadow);
  --shadow-floating:
    0 30px 70px rgba(16, 31, 30, 0.24), 0 14px 34px rgba(16, 31, 30, 0.14);
  --shadow-card: 0 10px 24px rgba(21, 37, 36, 0.08);
  --shadow-inset-highlight: inset 0 1px 0 rgba(255, 255, 255, 0.72);
  --shadow-inset-soft: inset 0 1px 0 rgba(255, 255, 255, 0.42);
  --shadow-card-subtle: 0 8px 18px rgba(15, 23, 42, 0.04);
  --shadow-card-subtle-hover: 0 10px 20px rgba(15, 23, 42, 0.05);
  --shadow-header-action:
    inset 0 1px 0 rgba(255, 255, 255, 0.72), 0 10px 18px rgba(15, 23, 42, 0.07);
  --shadow-header-action-hover:
    inset 0 1px 0 rgba(255, 255, 255, 0.8), 0 14px 24px rgba(15, 23, 42, 0.1);
  --shadow-header-action-pending:
    inset 0 1px 0 rgba(255, 255, 255, 0.72), 0 10px 18px rgba(15, 23, 42, 0.05);
  --shadow-button-ghost-hover: 0 16px 30px rgba(15, 92, 87, 0.1);
  --shadow-button-primary: 0 8px 18px rgba(15, 23, 42, 0.16);
  --shadow-button-primary-hover: 0 10px 22px rgba(15, 23, 42, 0.2);
  --shadow-button-optimize: 0 10px 26px rgba(15, 23, 42, 0.16);
  --shadow-button-optimize-hover: 0 12px 28px rgba(15, 23, 42, 0.2);
  --shadow-button-accent: 0 16px 34px rgba(15, 92, 87, 0.22);
  --shadow-button-accent-hover: 0 18px 38px rgba(15, 92, 87, 0.26);
  --shadow-button-warning: 0 16px 34px rgba(180, 83, 9, 0.24);
  --shadow-button-warning-hover: 0 18px 38px rgba(180, 83, 9, 0.28);
  --shadow-button-icon: 0 8px 18px rgba(10, 32, 37, 0.05);
  --shadow-button-icon-hover: 0 8px 18px rgba(10, 32, 37, 0.08);
  --shadow-metric:
    inset 0 1px 0 rgba(255, 255, 255, 0.88), 0 10px 24px rgba(0, 0, 0, 0.08);
  --shadow-chip:
    inset 0 1px 0 rgba(255, 255, 255, 0.62), 0 6px 14px rgba(0, 0, 0, 0.08);

  --font-sans: 'Plus Jakarta Sans', 'Segoe UI', sans-serif;
  --font-display: 'Space Grotesk', 'Plus Jakarta Sans', sans-serif;

  --z-index-overlay: 2280;
  --z-index-modal: 2300;
  --z-index-popover: 2200;

  --animate-popover-enter: popover-enter 180ms cubic-bezier(0.16, 1, 0.3, 1);
  --animate-page-loading-overlay: page-loading-overlay 180ms ease-out both;
  --animate-page-loading-dialog: page-loading-dialog 240ms ease-out both;
  --animate-page-loading-dot: page-loading-dot 1.1s ease-in-out infinite;
  --animate-dispatch-kpi-alert-blink: dispatch-kpi-alert-blink 1.05s ease-in-out infinite;
  --animate-today-stale-portal-blink: today-stale-portal-blink 1.05s ease-in-out infinite;
  --animate-dispatch-capture-arrival-blink: dispatch-capture-arrival-blink 1.05s ease-in-out 6;
  --animate-dispatch-capture-unread-blink: dispatch-capture-arrival-blink 1.05s ease-in-out infinite;
  --animate-dispatch-source-changes-pulse: dispatch-source-changes-pulse 2.4s ease-in-out infinite;
  --animate-driver-portal-update-spin: driver-portal-update-spin 1.8s linear infinite;
  --animate-driver-portal-update-pulse: driver-portal-update-pulse 2s ease-in-out infinite;
  --animate-fleet-haversine-route-warning-blink: fleet-haversine-route-warning-blink 1.05s ease-in-out infinite;
  --animate-linked-step-emphasis: linked-step-emphasis 1.65s ease-in-out 2;
  --animate-planning-toast-enter: planning-toast-enter 220ms
    cubic-bezier(0.16, 1, 0.3, 1) both;
  --animate-confirmation-modal-backdrop: confirmation-modal-backdrop 180ms
    ease-out both;
  --animate-confirmation-modal-panel: confirmation-modal-panel 220ms
    cubic-bezier(0.16, 1, 0.3, 1) both;

  @keyframes popover-enter {
    0% {
      opacity: 0;
      transform: translateY(-6px) scale(0.98);
    }
    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
  @keyframes page-loading-overlay {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes page-loading-dialog {
    0% {
      opacity: 0;
      transform: translateY(14px) scale(0.98);
    }
    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
  @keyframes page-loading-dot {
    0%,
    100% {
      opacity: 0.34;
      transform: scale(0.82);
    }
    50% {
      opacity: 1;
      transform: scale(1);
    }
  }
  @keyframes dispatch-kpi-alert-blink {
    0%,
    100% {
      opacity: 1;
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(197, 82, 74, 0.18);
    }
    50% {
      opacity: 0.78;
      transform: scale(1.08);
      box-shadow: 0 0 0 6px rgba(197, 82, 74, 0.08);
    }
  }
  @keyframes today-stale-portal-blink {
    0%,
    100% {
      opacity: 1;
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(183, 255, 42, 0.35);
    }
    50% {
      opacity: 0.72;
      transform: scale(1.08);
      box-shadow: 0 0 0 8px rgba(183, 255, 42, 0.14);
    }
  }
  @keyframes dispatch-capture-arrival-blink {
    0%,
    100% {
      opacity: 1;
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(183, 255, 42, 0);
      filter: brightness(1);
    }
    50% {
      opacity: 0.42;
      transform: scale(1.08);
      box-shadow:
        0 0 0 4px rgba(183, 255, 42, 0.95),
        0 0 16px 6px rgba(183, 255, 42, 0.55);
      filter: brightness(1.35);
    }
  }
  @keyframes dispatch-source-changes-pulse {
    0%,
    100% {
      opacity: 1;
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(197, 82, 74, 0.24);
    }
    50% {
      opacity: 0.84;
      transform: scale(1.04);
      box-shadow: 0 0 0 6px rgba(197, 82, 74, 0.12);
    }
  }
  @keyframes driver-portal-update-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes driver-portal-update-pulse {
    0%,
    100% {
      box-shadow: 0 0 0 0 rgba(15, 92, 87, 0.18);
    }
    50% {
      box-shadow: 0 0 0 6px rgba(15, 92, 87, 0.1);
    }
  }
  @keyframes fleet-haversine-route-warning-blink {
    0%,
    100% {
      opacity: 1;
      transform: scale(1);
      filter: drop-shadow(0 0 0 rgba(217, 119, 6, 0));
    }
    42% {
      opacity: 0.22;
      transform: scale(0.92);
      filter: drop-shadow(0 0 2px rgba(217, 119, 6, 0.24));
    }
    64% {
      opacity: 1;
      transform: scale(1.12);
      filter: drop-shadow(0 0 6px rgba(251, 191, 36, 0.42));
    }
  }
  @keyframes fleet-timeline-drop-highlight {
    0%,
    100% {
      transform: scale(1);
      box-shadow: 0 8px 16px rgba(15, 23, 42, 0.045);
    }
    45% {
      transform: scale(1.09);
      box-shadow:
        0 0 0 4px rgba(217, 119, 6, 0.34),
        0 0 0 10px rgba(251, 191, 36, 0.18),
        0 16px 28px rgba(217, 119, 6, 0.18);
    }
    70% {
      transform: scale(1.04);
      box-shadow:
        0 0 0 3px rgba(217, 119, 6, 0.24),
        0 0 0 7px rgba(251, 191, 36, 0.12),
        0 12px 22px rgba(217, 119, 6, 0.12);
    }
  }

  @keyframes optimization-preview-waiting-segment {
    0% {
      opacity: 0;
      transform: translateX(-100%);
    }

    38%, 62% {
      opacity: 0.9;
    }

    100% {
      opacity: 0;
      transform: translateX(400%);
    }
  }

  @keyframes optimization-preview-assignment-sweep {
    0%,
    18% {
      background-position: 145% 0;
      opacity: 0.12;
    }
    48% {
      opacity: 0.32;
    }
    72%,
    100% {
      background-position: -145% 0;
      opacity: 0.12;
    }
  }

  @keyframes linked-step-emphasis {
    0%,
    100% {
      box-shadow: 0 0 0 0 rgba(56, 99, 142, 0);
    }
    35% {
      box-shadow:
        0 0 0 3px rgba(56, 99, 142, 0.28),
        0 0 0 8px rgba(56, 99, 142, 0.12);
    }
    65% {
      box-shadow:
        0 0 0 2px rgba(56, 99, 142, 0.22),
        0 0 0 6px rgba(56, 99, 142, 0.08);
    }
  }
  @keyframes planning-toast-enter {
    0% {
      opacity: 0;
      transform: translate(-50%, calc(-50% + 14px));
    }
    100% {
      opacity: 1;
      transform: translate(-50%, -50%);
    }
  }
  @keyframes confirmation-modal-backdrop {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes confirmation-modal-panel {
    0% {
      opacity: 0;
      transform: translateY(14px) scale(0.97);
    }
    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
}

/* Optimization preview activity cues stay above the segment fill only through
 * translucent pseudo-elements, so the blue/yellow business colors remain intact. */
[data-optimization-preview-activity="assignments"][data-optimization-preview-animated="true"]
  [data-optimization-preview-group-id],
[data-optimization-preview-activity="dispatch-improvement"][data-optimization-preview-animated="true"]
  [data-optimization-preview-group-id] {
  isolation: isolate;
}

[data-optimization-preview-activity="assignments"][data-optimization-preview-animated="true"]
  [data-optimization-preview-group-id]::after,
[data-optimization-preview-activity="dispatch-improvement"][data-optimization-preview-animated="true"]
  [data-optimization-preview-group-id]::after {
  content: "";
  position: absolute;
  z-index: 0;
  inset: 0;
  pointer-events: none;
  border-radius: inherit;
  background: var(
    --optimization-preview-sweep-background,
    linear-gradient(
      112deg,
      transparent 32%,
      rgba(255, 255, 255, 0.04) 40%,
      rgba(255, 255, 255, 0.42) 49%,
      rgba(255, 255, 255, 0.08) 56%,
      transparent 68%
    )
  );
  background-size: 250% 100%;
  background-position: 145% 0;
  opacity: 0.12;
  mix-blend-mode: var(--optimization-preview-sweep-blend-mode, screen);
  animation: optimization-preview-assignment-sweep 3s ease-in-out infinite;
  animation-delay: calc(var(--optimization-preview-activity-index, 0) * -180ms);
}

/* Yellow delivery previews need an opaque adaptive highlight so the sweep
 * remains visible without changing the business segment color underneath. */
[data-optimization-preview-activity="assignments"][data-optimization-preview-animated="true"]
  [data-optimization-preview-group-id][data-optimization-preview-step-type="delivery"]::after,
[data-optimization-preview-activity="dispatch-improvement"][data-optimization-preview-animated="true"]
  [data-optimization-preview-group-id][data-optimization-preview-step-type="delivery"]::after {
  --optimization-preview-sweep-background: linear-gradient(
    112deg,
    transparent 32%,
    rgba(180, 124, 24, 0.14) 40%,
    rgba(255, 255, 255, 0.7) 47%,
    rgba(255, 255, 255, 0.92) 51%,
    rgba(180, 124, 24, 0.38) 58%,
    transparent 68%
  );
  --optimization-preview-sweep-blend-mode: normal;
}

[data-optimization-preview-activity="assignments"][data-optimization-preview-animated="true"]
  [data-optimization-preview-group-id] > *,
[data-optimization-preview-activity="dispatch-improvement"][data-optimization-preview-animated="true"]
  [data-optimization-preview-group-id] > * {
  position: relative;
  z-index: 1;
}

@media (prefers-reduced-motion: reduce) {
  [data-optimization-preview-activity="assignments"][data-optimization-preview-animated="true"]
    [data-optimization-preview-group-id]::after,
  [data-optimization-preview-activity="dispatch-improvement"][data-optimization-preview-animated="true"]
    [data-optimization-preview-group-id]::after {
    animation: none;
    background-position: 50% 0;
    opacity: 0.2;
  }
}

/*
  The default border color has changed to `currentcolor` in Tailwind CSS v4,
  so we've added these compatibility styles to make sure everything still
  looks the same as it did with Tailwind CSS v3.

  If we ever want to remove these styles, we need to add an explicit border
  color utility to any element that depends on these defaults.
*/
@layer base {
  *,
  ::after,
  ::before,
  ::backdrop,
  ::file-selector-button {
    border-color: var(--color-gray-200, currentcolor);
  }

  html {
    font-size: 14px;
    scroll-behavior: smooth;
    overflow-y: auto;
    scrollbar-gutter: auto;
  }

  body {
    margin: 0;
    background: var(--bg);
    color: var(--text);
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  ul {
    padding-left: 1.15rem;
  }
}

@utility toast-loading-spinner {
  [data-react-toast-stack='true'] & {
    color: var(--color-accent);
    animation-duration: 1s;
    animation-timing-function: linear;
    transform-origin: center;
  }
}

@utility bg-surface-results {
  background: var(--results-shell-main);
}

@utility bg-surface-results-topbar {
  background: var(--results-shell-nav);
}

@utility bg-surface-results-sidebar {
  background: var(--results-shell-periphery);
}

@utility bg-surface-results-nav {
  background: var(--results-shell-nav);
}

@utility bg-gradient-nav-active {
  background: var(--color-brand-light);
}

@utility bg-gradient-action-soft {
  background: var(--color-brand-light);
}

@utility bg-gradient-action-neutral {
  background: var(--panel);
}

@utility bg-gradient-indicator-success {
  background-image: linear-gradient(180deg, rgba(243, 250, 245, 0.96), rgba(232, 243, 235, 0.92));
}

@utility bg-gradient-indicator-warning {
  background-image: linear-gradient(180deg, rgba(250, 247, 240, 0.96), rgba(245, 239, 227, 0.92));
}

@utility bg-gradient-indicator-danger {
  background-image: linear-gradient(180deg, rgba(252, 244, 243, 0.96), rgba(247, 234, 232, 0.92));
}

@utility bg-gradient-indicator-info {
  background-image: linear-gradient(180deg, rgba(245, 248, 249, 0.96), rgba(235, 240, 241, 0.92));
}

@utility bg-gradient-indicator-neutral {
  background-image: linear-gradient(180deg, rgba(250, 251, 249, 0.96), rgba(241, 244, 240, 0.92));
}

@utility bg-gradient-status-manual {
  background-image: linear-gradient(180deg, rgba(241, 171, 76, 0.98), rgba(216, 129, 39, 0.98));
}

@utility bg-gradient-pill-idle {
  background-image: linear-gradient(180deg, rgba(219, 225, 231, 0.98), rgba(198, 206, 214, 0.98));
}

@utility bg-gradient-pill-info {
  background-image: linear-gradient(180deg, rgba(220, 230, 224, 0.98), rgba(205, 217, 210, 0.98));
}

@utility bg-gradient-pill-success {
  background-image: linear-gradient(180deg, rgba(184, 220, 190, 0.98), rgba(159, 201, 167, 0.98));
}

@utility bg-gradient-button-primary {
  background: var(--color-brand);
}

@utility bg-gradient-button-primary-hover {
  background: var(--color-brand-dark);
}

@utility bg-gradient-button-optimize {
  background: #374151;
}

@utility bg-gradient-button-optimize-hover {
  background: #1f2937;
}

@utility bg-gradient-button-accent {
  background: var(--color-brand);
}

@utility bg-gradient-button-warning {
  background-image: linear-gradient(135deg, rgba(217, 119, 6, 1), rgba(180, 83, 9, 1));
}

@utility bg-gradient-button-icon-success {
  background-image: linear-gradient(180deg, rgba(245, 252, 247, 0.98), rgba(229, 245, 235, 0.98));
}

@utility bg-gradient-button-icon-success-hover {
  background-image: linear-gradient(180deg, rgba(239, 249, 242, 0.99), rgba(220, 241, 227, 0.99));
}

@utility bg-gradient-button-icon-success-active {
  background-image: linear-gradient(160deg, #3e9454 0%, var(--color-accent) 48%, #184d2c 100%);
}

@utility bg-gradient-button-icon-success-blocked {
  background-image: linear-gradient(180deg, rgba(244, 248, 253, 0.98), rgba(223, 234, 247, 0.98));
}

@utility bg-gradient-button-icon-reassign-active {
  background-image: linear-gradient(180deg, rgba(241, 225, 180, 0.98), rgba(226, 198, 118, 0.98));
}

@utility bg-gradient-empty-default {
  background: var(--panel);
}

@utility bg-gradient-empty-success {
  background: #f0fdf4;
}

@utility shadow-icon-inset {
  box-shadow: var(--shadow-inset-highlight);
}

@utility bg-gradient-notice-running {
  background: #f9fafb;
}

@utility bg-gradient-notice-success {
  background: #f0fdf4;
}

@utility bg-gradient-notice-danger {
  background: #fef2f2;
}

@layer utilities {
  html,
  body {
    min-height: 100vh;
    background-color: var(--bg);
  }

  body {
    position: relative;
  }

  body::before {
    display: none;
    content: '';
    position: fixed;
    inset: 0;
    background: none;
    z-index: 0;
    pointer-events: none;
  }

  body::after {
    display: none;
  }

  body > * {
    position: relative;
    z-index: 1;
  }

}

@layer components {
  .page-shell {
    padding: 0;
  }

  table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    min-width: 760px;
    font-size: 0.82rem;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 9px 10px;
    text-align: left;
    font-size: 0.7rem;
    font-weight: 800;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: var(--muted-strong);
    background: #f4f8f7;
    border-bottom: 1px solid var(--line);
  }

  tbody td {
    padding: 9px 10px;
    border-bottom: 1px solid #edf3f2;
    vertical-align: top;
    color: var(--text);
    line-height: 1.35;
  }

  tbody tr:nth-child(even) {
    background: rgba(246, 250, 249, 0.76);
  }

  tbody tr:hover {
    background: rgba(215, 239, 234, 0.26);
  }

  tbody tr:last-child td {
    border-bottom: 0;
  }

  /*
   * Colour intensity infrastructure for the whole authenticated shell.
   * The preference hook writes the five unitless deltas on document.body;
   * weights and shared soft tokens live here so Import / Dashboard / etc.
   * react to the same slider as Dispatch.
   */
  body.page-shell {
    --dispatch-segment-fill-delta: 0;
    --dispatch-segment-border-delta: 0;
    --dispatch-soft-fill-delta: 0;
    --dispatch-chip-fill-delta: 0;
    --dispatch-colored-border-delta: 0;
    --dispatch-color-intensity-percent: 0;

    --dispatch-neutral-segment-fill-delta: calc(var(--dispatch-segment-fill-delta, 0) * 0.5);
    --dispatch-neutral-segment-border-delta: calc(var(--dispatch-segment-border-delta, 0) * 0.5);
    --dispatch-neutral-soft-fill-delta: calc(var(--dispatch-soft-fill-delta, 0) * 0.5);
    --dispatch-neutral-chip-fill-delta: calc(var(--dispatch-chip-fill-delta, 0) * 0.5);
    --dispatch-neutral-colored-border-delta: calc(var(--dispatch-colored-border-delta, 0) * 0.5);

    --dispatch-soft-darken-alpha: clamp(0, var(--dispatch-soft-fill-delta, 0), 1);
    --dispatch-soft-lighten-alpha: clamp(0, calc(0 - var(--dispatch-soft-fill-delta, 0)), 1);
    --dispatch-neutral-soft-darken-alpha: clamp(0, var(--dispatch-neutral-soft-fill-delta), 1);
    --dispatch-neutral-soft-lighten-alpha: clamp(0, calc(0 - var(--dispatch-neutral-soft-fill-delta)), 1);
    --dispatch-chip-darken-alpha: clamp(0, var(--dispatch-chip-fill-delta, 0), 1);
    --dispatch-chip-lighten-alpha: clamp(0, calc(0 - var(--dispatch-chip-fill-delta, 0)), 1);
    --dispatch-neutral-chip-darken-alpha: clamp(0, var(--dispatch-neutral-chip-fill-delta), 1);
    --dispatch-neutral-chip-lighten-alpha: clamp(0, calc(0 - var(--dispatch-neutral-chip-fill-delta)), 1);
    /*
     * Chrome / KPI cards / action chips (M-à-J, badges):
     * 0% matches the former +10% look (baseline darken ≈ 0.10).
     * Above 0%, darken grows gently (~0.004 per %) so reds/oranges stay unsaturated
     * (~0.22 at +30%, ~0.34 at +60% instead of 0.30 / 0.60).
     * Negative values lighten from that baseline.
     */
    --dispatch-chrome-soft-darken-alpha: clamp(0, calc(0.10 + var(--dispatch-color-intensity-percent, 0) * 0.004), 1);
    --dispatch-chrome-soft-lighten-alpha: clamp(0, calc(var(--dispatch-color-intensity-percent, 0) * -0.006), 1);
    --dispatch-chrome-chip-darken-alpha: clamp(0, calc(0.10 + var(--dispatch-color-intensity-percent, 0) * 0.004), 1);
    --dispatch-chrome-chip-lighten-alpha: clamp(0, calc(var(--dispatch-color-intensity-percent, 0) * -0.006), 1);
    --dispatch-chrome-neutral-soft-darken-alpha: clamp(0, calc(var(--dispatch-chrome-soft-darken-alpha) * 0.55), 1);
    --dispatch-chrome-neutral-soft-lighten-alpha: clamp(0, calc(var(--dispatch-chrome-soft-lighten-alpha) * 0.55), 1);
    --dispatch-chrome-chip-darken-weight: clamp(0%, calc(var(--dispatch-chrome-chip-darken-alpha) * 100%), 100%);
    --dispatch-chrome-chip-lighten-weight: clamp(0%, calc(var(--dispatch-chrome-chip-lighten-alpha) * 100%), 100%);
    --dispatch-chip-darken-weight: clamp(0%, calc(var(--dispatch-chip-darken-alpha) * 100%), 100%);
    --dispatch-chip-lighten-weight: clamp(0%, calc(var(--dispatch-chip-lighten-alpha) * 100%), 100%);
    --dispatch-neutral-chip-darken-weight: clamp(0%, calc(var(--dispatch-neutral-chip-darken-alpha) * 100%), 100%);
    --dispatch-neutral-chip-lighten-weight: clamp(0%, calc(var(--dispatch-neutral-chip-lighten-alpha) * 100%), 100%);
    /*
     * Solid brand / CTA (Optimiser, Rapports, Import, Data Manager…):
     * 0% keeps the historical #0f5c57; positive intensity darkens visibly.
     */
    --shell-brand-solid-darken-weight: clamp(0%, calc(var(--dispatch-color-intensity-percent, 0) * 0.55%), 36%);
    --shell-brand-solid-lighten-weight: clamp(0%, calc(var(--dispatch-color-intensity-percent, 0) * -0.7%), 20%);
    --color-brand: color-mix(in srgb, color-mix(in srgb, #0f5c57, #021f1c var(--shell-brand-solid-darken-weight)), white var(--shell-brand-solid-lighten-weight));
    --color-brand-dark: color-mix(in srgb, color-mix(in srgb, #0a4945, #011614 var(--shell-brand-solid-darken-weight)), white var(--shell-brand-solid-lighten-weight));
    --color-accent: var(--color-brand);
    --color-accent-strong: var(--color-brand-dark);
    --color-legacy-teal: var(--color-brand);
    --color-legacy-teal-strong: var(--color-brand-dark);
    --shell-optimizer-button: var(--color-brand);
    --shell-optimizer-button-hover: var(--color-brand-dark);
    /*
     * Pastilles de champs (Rapports / Import / Data Manager) :
     * 0% ≈ slate-50 historique ; l’intensité reste neutre (gris), sans dérive verte.
     */
    --shell-control-pastille-tint-weight: clamp(0%, calc(var(--dispatch-color-intensity-percent, 0) * 0.18%), 12%);
    --shell-control-pastille-lighten-weight: clamp(0%, calc(var(--dispatch-color-intensity-percent, 0) * -0.35%), 12%);
    --shell-control-pastille-border-tint-weight: clamp(0%, calc(4% + var(--dispatch-color-intensity-percent, 0) * 0.14%), 14%);
    --shell-control-pastille-fill: color-mix(in srgb, color-mix(in srgb, rgb(248 250 252 / 0.92), #64748b var(--shell-control-pastille-tint-weight)), white var(--shell-control-pastille-lighten-weight));
    --shell-control-pastille-border: color-mix(in srgb, color-mix(in srgb, #e2e8f0, #94a3b8 var(--shell-control-pastille-border-tint-weight)), white var(--shell-control-pastille-lighten-weight));
    --shell-control-info-fill: color-mix(in srgb, color-mix(in srgb, #f8fafc, #64748b clamp(0%, calc(var(--dispatch-color-intensity-percent, 0) * 0.12%), 10%)), white var(--shell-control-pastille-lighten-weight));
    --shell-control-info-border: var(--shell-control-pastille-border);
    /* Status banners: historical red-50 / green-50 / amber-50 at 0%, then intensify. */
    --shell-notice-danger-fill: color-mix(in srgb, color-mix(in srgb, #fecaca, #b91c1c var(--dispatch-chrome-chip-darken-weight)), white var(--dispatch-chrome-chip-lighten-weight));
    --shell-notice-success-fill: color-mix(in srgb, color-mix(in srgb, #f0fdf4, #166534 var(--dispatch-chrome-chip-darken-weight)), white var(--dispatch-chrome-chip-lighten-weight));
    --shell-notice-warning-fill: color-mix(in srgb, color-mix(in srgb, #fffbeb, #b45309 var(--dispatch-chrome-chip-darken-weight)), white var(--dispatch-chrome-chip-lighten-weight));
    --color-shell-notice-danger-border: rgb(197 82 74 / clamp(0, calc(0.28 + var(--dispatch-color-intensity-percent, 0) * 0.004), 1));
    --color-shell-notice-success-border: rgb(92 148 104 / clamp(0, calc(0.34 + var(--dispatch-color-intensity-percent, 0) * 0.004), 1));
    --dispatch-colored-border-darken-alpha: clamp(0, var(--dispatch-colored-border-delta, 0), 1);
    --dispatch-colored-border-lighten-alpha: clamp(0, calc(0 - var(--dispatch-colored-border-delta, 0)), 1);
    --dispatch-colored-border-darken-weight: clamp(0%, calc(var(--dispatch-colored-border-darken-alpha) * 100%), 100%);
    --dispatch-colored-border-lighten-weight: clamp(0%, calc(var(--dispatch-colored-border-lighten-alpha) * 100%), 100%);
    --dispatch-neutral-border-darken-alpha: clamp(0, var(--dispatch-neutral-colored-border-delta), 1);
    --dispatch-neutral-border-lighten-alpha: clamp(0, calc(0 - var(--dispatch-neutral-colored-border-delta)), 1);
    --dispatch-neutral-border-darken-weight: clamp(0%, calc(var(--dispatch-neutral-border-darken-alpha) * 100%), 100%);
    --dispatch-neutral-border-lighten-weight: clamp(0%, calc(var(--dispatch-neutral-border-lighten-alpha) * 100%), 100%);

    /* Shared soft fills used by Pill / StatusBadge / header chrome */
    --amber-soft: color-mix(in srgb, color-mix(in srgb, #f4e1c6, #d08b3e var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --danger-soft: color-mix(in srgb, color-mix(in srgb, #fecaca, #b91c1c var(--dispatch-chrome-chip-darken-weight)), white var(--dispatch-chrome-chip-lighten-weight));
    --neutral-soft: color-mix(in srgb, color-mix(in srgb, #eef2f5, #64748b var(--dispatch-neutral-chip-darken-weight)), white var(--dispatch-neutral-chip-lighten-weight));
    --grain-badge-bg: color-mix(in srgb, color-mix(in srgb, rgba(229, 238, 232, 0.96), #3e5d50 var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --color-brand-light: color-mix(in srgb, color-mix(in srgb, #ecfdf5, #0f5c57 var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --color-legacy-green-soft: color-mix(in srgb, color-mix(in srgb, #d8f2e7, #16775d var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --color-legacy-teal-soft: color-mix(in srgb, color-mix(in srgb, #d7efea, #0f5c57 var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --route-loading-soft: color-mix(in srgb, color-mix(in srgb, #e8eef9, #5a79be var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --route-delivery-soft: color-mix(in srgb, color-mix(in srgb, #f4efdb, #968a3e var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));

    --pill-success-fill: color-mix(in srgb, color-mix(in srgb, #b8dcbe, #1c4627 var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --pill-idle-fill: color-mix(in srgb, color-mix(in srgb, #dbe1e7, #64748b var(--dispatch-neutral-chip-darken-weight)), white var(--dispatch-neutral-chip-lighten-weight));
    --pill-info-fill: color-mix(in srgb, color-mix(in srgb, #dce6e0, #3e5d50 var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --pill-manual-fill: color-mix(in srgb, color-mix(in srgb, rgb(241 171 76), #9a5b12 var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --color-border-manual-subtle: rgb(161 93 20 / clamp(0, calc(0.22 + var(--dispatch-colored-border-delta, 0)), 1));
    --report-status-success-fill: color-mix(in srgb, color-mix(in srgb, rgba(223, 243, 240, 0.9), #0f5c57 var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --report-status-warning-fill: color-mix(in srgb, color-mix(in srgb, rgba(255, 247, 237, 0.94), #b45309 var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --report-status-danger-fill: color-mix(in srgb, color-mix(in srgb, rgba(254, 226, 226, 0.96), #b91c1c var(--dispatch-chrome-chip-darken-weight)), white var(--dispatch-chrome-chip-lighten-weight));

    --color-border-warning-subtle: rgb(208 139 62 / clamp(0, calc(0.14 + var(--dispatch-colored-border-delta, 0)), 1));
    --color-border-warning-muted: rgb(208 139 62 / clamp(0, calc(0.16 + var(--dispatch-colored-border-delta, 0)), 1));
    --color-border-warning-strong: rgb(208 139 62 / clamp(0, calc(0.24 + var(--dispatch-colored-border-delta, 0)), 1));
    --color-border-warning-badge: rgb(217 119 6 / clamp(0, calc(0.16 + var(--dispatch-colored-border-delta, 0)), 1));
    --color-border-danger-subtle: rgb(197 82 74 / clamp(0, calc(0.14 + var(--dispatch-colored-border-delta, 0)), 1));
    --color-border-danger-muted: rgb(197 82 74 / clamp(0, calc(0.18 + var(--dispatch-colored-border-delta, 0)), 1));
    --color-border-danger-strong: rgb(197 82 74 / clamp(0, calc(0.30 + var(--dispatch-colored-border-delta, 0)), 1));
    --color-border-success-strong: rgb(28 70 39 / clamp(0, calc(0.34 + var(--dispatch-colored-border-delta, 0)), 1));
    --color-border-success-soft: rgb(22 119 93 / clamp(0, calc(0.14 + var(--dispatch-colored-border-delta, 0)), 1));
    --color-border-success-subtle: rgb(47 127 72 / clamp(0, calc(0.20 + var(--dispatch-colored-border-delta, 0)), 1));
    --color-border-success-muted: rgb(47 127 72 / clamp(0, calc(0.28 + var(--dispatch-colored-border-delta, 0)), 1));
    --color-border-header-success: rgb(74 130 92 / clamp(0, calc(0.22 + var(--dispatch-colored-border-delta, 0)), 1));
    --color-border-header-warning: rgb(187 153 92 / clamp(0, calc(0.24 + var(--dispatch-colored-border-delta, 0)), 1));
    --color-border-header-danger: rgb(192 116 108 / clamp(0, calc(0.22 + var(--dispatch-colored-border-delta, 0)), 1));

    /* Tailwind soft palette used heavily outside Dispatch (Data Manager, notices, etc.) */
    --color-green-50: color-mix(in srgb, color-mix(in srgb, #f0fdf4, #166534 var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --color-green-100: color-mix(in srgb, color-mix(in srgb, #dcfce7, #166534 var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --color-emerald-50: color-mix(in srgb, color-mix(in srgb, #ecfdf5, #047857 var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --color-amber-50: color-mix(in srgb, color-mix(in srgb, #fffbeb, #b45309 var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --color-amber-100: color-mix(in srgb, color-mix(in srgb, #fef3c7, #b45309 var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --color-yellow-50: color-mix(in srgb, color-mix(in srgb, #fefce8, #a16207 var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --color-orange-50: color-mix(in srgb, color-mix(in srgb, #fff7ed, #c2410c var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --color-rose-50: color-mix(in srgb, color-mix(in srgb, #fff1f2, #be123c var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --color-red-50: color-mix(in srgb, color-mix(in srgb, #fef2f2, #b91c1c var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --color-sky-50: color-mix(in srgb, color-mix(in srgb, #f0f9ff, #0369a1 var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --color-green-200: color-mix(in srgb, color-mix(in srgb, #bbf7d0, #166534 var(--dispatch-colored-border-darken-weight)), white var(--dispatch-colored-border-lighten-weight));
    --color-amber-200: color-mix(in srgb, color-mix(in srgb, #fde68a, #b45309 var(--dispatch-colored-border-darken-weight)), white var(--dispatch-colored-border-lighten-weight));
    --color-rose-200: color-mix(in srgb, color-mix(in srgb, #fecdd3, #be123c var(--dispatch-colored-border-darken-weight)), white var(--dispatch-colored-border-lighten-weight));
    --color-sky-200: color-mix(in srgb, color-mix(in srgb, #bae6fd, #0369a1 var(--dispatch-colored-border-darken-weight)), white var(--dispatch-colored-border-lighten-weight));
    --color-orange-200: color-mix(in srgb, color-mix(in srgb, #fed7aa, #c2410c var(--dispatch-colored-border-darken-weight)), white var(--dispatch-colored-border-lighten-weight));
    --color-emerald-200: color-mix(in srgb, color-mix(in srgb, #a7f3d0, #047857 var(--dispatch-colored-border-darken-weight)), white var(--dispatch-colored-border-lighten-weight));

    /* Dashboard soft surfaces */
    --dashboard-metric-amber-fill: color-mix(in srgb, color-mix(in srgb, rgba(255, 248, 238, 0.92), #c49655 var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --dashboard-metric-sage-fill: color-mix(in srgb, color-mix(in srgb, rgba(247, 250, 247, 0.88), #5f7f72 var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --dashboard-metric-slate-fill: color-mix(in srgb, color-mix(in srgb, rgba(245, 249, 251, 0.9), #5e7684 var(--dispatch-neutral-chip-darken-weight)), white var(--dispatch-neutral-chip-lighten-weight));
    --dashboard-metric-teal-fill: color-mix(in srgb, color-mix(in srgb, rgba(239, 249, 246, 0.9), #46796f var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --dashboard-metric-amber-border: rgb(191 155 94 / clamp(0, calc(0.16 + var(--dispatch-colored-border-delta, 0)), 1));
    --dashboard-metric-sage-border: rgb(105 136 122 / clamp(0, calc(0.14 + var(--dispatch-colored-border-delta, 0)), 1));
    --dashboard-metric-slate-border: rgb(115 134 145 / clamp(0, calc(0.15 + var(--dispatch-neutral-colored-border-delta)), 1));
    --dashboard-metric-teal-border: rgb(93 141 131 / clamp(0, calc(0.15 + var(--dispatch-colored-border-delta, 0)), 1));
    --dashboard-panel-amber-surface:
      linear-gradient(rgb(196 150 85 / var(--dispatch-soft-darken-alpha)), rgb(196 150 85 / var(--dispatch-soft-darken-alpha))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-soft-lighten-alpha)), rgb(255 255 255 / var(--dispatch-soft-lighten-alpha))),
      radial-gradient(circle at top left, rgba(255, 243, 224, 0.94), rgba(255, 249, 241, 0.96) 50%, rgba(255, 255, 255, 0.98) 100%);
    --dashboard-panel-sage-surface:
      linear-gradient(rgb(95 127 114 / var(--dispatch-soft-darken-alpha)), rgb(95 127 114 / var(--dispatch-soft-darken-alpha))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-soft-lighten-alpha)), rgb(255 255 255 / var(--dispatch-soft-lighten-alpha))),
      radial-gradient(circle at top left, rgba(234, 242, 236, 0.92), rgba(255, 249, 239, 0.95) 48%, rgba(255, 255, 255, 0.98) 100%);
    --dashboard-panel-slate-surface:
      linear-gradient(rgb(94 118 132 / var(--dispatch-neutral-soft-darken-alpha)), rgb(94 118 132 / var(--dispatch-neutral-soft-darken-alpha))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-neutral-soft-lighten-alpha)), rgb(255 255 255 / var(--dispatch-neutral-soft-lighten-alpha))),
      radial-gradient(circle at top left, rgba(233, 241, 245, 0.94), rgba(248, 251, 252, 0.96) 48%, rgba(255, 255, 255, 0.98) 100%);
    --dashboard-panel-teal-surface:
      linear-gradient(rgb(70 121 111 / var(--dispatch-soft-darken-alpha)), rgb(70 121 111 / var(--dispatch-soft-darken-alpha))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-soft-lighten-alpha)), rgb(255 255 255 / var(--dispatch-soft-lighten-alpha))),
      radial-gradient(circle at top left, rgba(227, 243, 240, 0.94), rgba(246, 250, 248, 0.96) 50%, rgba(255, 255, 255, 0.98) 100%);
    --dashboard-panel-amber-border: rgb(171 138 85 / clamp(0, calc(0.16 + var(--dispatch-colored-border-delta, 0)), 1));
    --dashboard-panel-sage-border: rgb(94 112 100 / clamp(0, calc(0.13 + var(--dispatch-colored-border-delta, 0)), 1));
    --dashboard-panel-slate-border: rgb(104 123 132 / clamp(0, calc(0.14 + var(--dispatch-neutral-colored-border-delta)), 1));
    --dashboard-panel-teal-border: rgb(90 132 122 / clamp(0, calc(0.15 + var(--dispatch-colored-border-delta, 0)), 1));
  }

  body.page-shell:has(.consolidation-dispatch-gantt),
  body.results-page,
  .driver-portal,
  .consolidation-dispatch-gantt,
  /* HoverCards render outside the preview through the shared React portal. */
  body:has(.consolidation-dispatch-gantt) #react-portal-root {
    --content-width: 1760px;
    /*
     * Dispatch colour intensity palette. Delta weights are inherited from
     * body.page-shell so the same slider drives timeline chips and shared UI.
     */
    --dispatch-route-loading-rgb: 90 121 190;
    --dispatch-route-delivery-rgb: 150 138 62;

    --dispatch-soft-overlay-loading:
      linear-gradient(rgb(var(--dispatch-route-loading-rgb) / var(--dispatch-soft-darken-alpha)), rgb(var(--dispatch-route-loading-rgb) / var(--dispatch-soft-darken-alpha))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-soft-lighten-alpha)), rgb(255 255 255 / var(--dispatch-soft-lighten-alpha)));
    --dispatch-soft-overlay-delivery:
      linear-gradient(rgb(var(--dispatch-route-delivery-rgb) / var(--dispatch-soft-darken-alpha)), rgb(var(--dispatch-route-delivery-rgb) / var(--dispatch-soft-darken-alpha))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-soft-lighten-alpha)), rgb(255 255 255 / var(--dispatch-soft-lighten-alpha)));
    --dispatch-soft-overlay-return:
      linear-gradient(rgb(15 92 87 / var(--dispatch-soft-darken-alpha)), rgb(15 92 87 / var(--dispatch-soft-darken-alpha))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-soft-lighten-alpha)), rgb(255 255 255 / var(--dispatch-soft-lighten-alpha)));
    --dispatch-soft-overlay-preload:
      linear-gradient(rgb(122 143 184 / var(--dispatch-soft-darken-alpha)), rgb(122 143 184 / var(--dispatch-soft-darken-alpha))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-soft-lighten-alpha)), rgb(255 255 255 / var(--dispatch-soft-lighten-alpha)));
    --dispatch-soft-overlay-success:
      linear-gradient(rgb(15 118 110 / var(--dispatch-chrome-soft-darken-alpha, 0)), rgb(15 118 110 / var(--dispatch-chrome-soft-darken-alpha, 0))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-chrome-soft-lighten-alpha, 0)), rgb(255 255 255 / var(--dispatch-chrome-soft-lighten-alpha, 0)));
    --dispatch-soft-overlay-warning:
      linear-gradient(rgb(217 119 6 / var(--dispatch-chrome-soft-darken-alpha, 0)), rgb(217 119 6 / var(--dispatch-chrome-soft-darken-alpha, 0))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-chrome-soft-lighten-alpha, 0)), rgb(255 255 255 / var(--dispatch-chrome-soft-lighten-alpha, 0)));
    --dispatch-soft-overlay-danger:
      linear-gradient(rgb(185 28 28 / var(--dispatch-chrome-soft-darken-alpha, 0)), rgb(185 28 28 / var(--dispatch-chrome-soft-darken-alpha, 0))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-chrome-soft-lighten-alpha, 0)), rgb(255 255 255 / var(--dispatch-chrome-soft-lighten-alpha, 0)));
    --dispatch-soft-overlay-neutral:
      linear-gradient(rgb(100 116 139 / var(--dispatch-chrome-neutral-soft-darken-alpha)), rgb(100 116 139 / var(--dispatch-chrome-neutral-soft-darken-alpha))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-chrome-neutral-soft-lighten-alpha)), rgb(255 255 255 / var(--dispatch-chrome-neutral-soft-lighten-alpha)));

    /*
     * Gantt / sequence headroom above the plateaued segmentFillDelta (≈0.25).
     * Fill boost is paired with ink darkening so text contrast stays ≥ 4.5:1.
     */
    --dispatch-segment-intensity-fill-boost: clamp(0, calc(var(--dispatch-color-intensity-percent, 0) * 0.002), 0.12);
    --dispatch-segment-intensity-border-boost: clamp(0, calc(var(--dispatch-color-intensity-percent, 0) * 0.0035), 0.22);
    --dispatch-sequence-marker-darken-weight: clamp(0%, calc(var(--dispatch-color-intensity-percent, 0) * 0.32%), 22%);
    /*
     * Text/ink: front-loaded (steeper early, plateaus sooner) so labels punch
     * sooner than fills without keeping a long gradual ramp.
     */
    --dispatch-segment-ink-darken-weight: clamp(0%, calc(var(--dispatch-color-intensity-percent, 0) * 1.05%), 34%);

    /* Muted Gantt tones; keep the existing intensity control and service timing.
       Chargement : bleu un peu plus franc. Livraison : beige sable plus pâle, sans pointe olive. */
    --dispatch-segment-loading-rgb: 131 160 197;
    --dispatch-segment-delivery-rgb: 183 155 83;
    --dispatch-segment-loading-ink: color-mix(in srgb, #1c3048, #0f172a var(--dispatch-segment-ink-darken-weight));
    --dispatch-segment-delivery-ink: color-mix(in srgb, #373018, #1c1917 var(--dispatch-segment-ink-darken-weight));
    --dispatch-segment-loading-tone: color-mix(in srgb, rgb(var(--dispatch-segment-loading-rgb)) clamp(0%, calc((0.435 + var(--dispatch-segment-fill-delta, 0) + var(--dispatch-segment-intensity-fill-boost, 0)) * 100%), 100%), white);
    --dispatch-segment-loading-fill: color-mix(in srgb, var(--dispatch-segment-loading-tone) 72%, white);
    --dispatch-segment-loading-border: rgb(var(--dispatch-segment-loading-rgb) / clamp(0, calc(0.50 + var(--dispatch-segment-border-delta, 0) + var(--dispatch-segment-intensity-border-boost, 0)), 1));
    --dispatch-segment-delivery-tone: color-mix(in srgb, rgb(var(--dispatch-segment-delivery-rgb)) clamp(0%, calc((0.188 + var(--dispatch-segment-fill-delta, 0) + var(--dispatch-segment-intensity-fill-boost, 0)) * 100%), 100%), white);
    --dispatch-segment-delivery-fill: color-mix(in srgb, var(--dispatch-segment-delivery-tone) 72%, white);
    --dispatch-segment-delivery-border: rgb(var(--dispatch-segment-delivery-rgb) / clamp(0, calc(0.50 + var(--dispatch-segment-border-delta, 0) + var(--dispatch-segment-intensity-border-boost, 0)), 1));
    --dispatch-segment-return-fill: color-mix(in srgb, var(--color-accent) clamp(0%, calc((0.15 + var(--dispatch-segment-fill-delta, 0) + var(--dispatch-segment-intensity-fill-boost, 0)) * 100%), 100%), transparent);
    --dispatch-segment-return-border: color-mix(in srgb, var(--color-accent) clamp(0%, calc((0.31 + var(--dispatch-segment-border-delta, 0) + var(--dispatch-segment-intensity-border-boost, 0)) * 100%), 100%), transparent);
    --dispatch-segment-return-ink: color-mix(in srgb, var(--color-accent-strong) calc(82% - var(--dispatch-segment-ink-darken-weight)), black);
    /* Inspection shares the menu hue, with a lighter fill than a depot return. */
    --dispatch-segment-inspection-fill: color-mix(in srgb, var(--color-accent) clamp(0%, calc((0.10 + var(--dispatch-segment-fill-delta, 0) + var(--dispatch-segment-intensity-fill-boost, 0)) * 100%), 100%), white);
    --dispatch-segment-inspection-border: color-mix(in srgb, var(--color-accent) clamp(0%, calc((0.24 + var(--dispatch-segment-border-delta, 0) + var(--dispatch-segment-intensity-border-boost, 0)) * 100%), 100%), transparent);
    --dispatch-segment-preload-fill: rgb(122 143 184 / clamp(0, calc(0.23 + var(--dispatch-segment-fill-delta, 0) + var(--dispatch-segment-intensity-fill-boost, 0)), 1));
    --dispatch-segment-preload-border: rgb(122 143 184 / clamp(0, calc(0.45 + var(--dispatch-segment-border-delta, 0) + var(--dispatch-segment-intensity-border-boost, 0)), 1));
    --dispatch-segment-loading-accent: var(--dispatch-segment-loading-border);
    --dispatch-segment-delivery-accent: var(--dispatch-segment-delivery-border);
    --dispatch-segment-return-accent: var(--dispatch-segment-return-border);
    --dispatch-segment-preload-accent: rgb(122 143 184 / clamp(0, calc(0.35 + var(--dispatch-segment-border-delta, 0) + var(--dispatch-segment-intensity-border-boost, 0)), 1));
    --dispatch-legend-loading-border: var(--dispatch-segment-loading-border);
    --dispatch-legend-delivery-border: var(--dispatch-segment-delivery-border);
    --dispatch-legend-return-border: color-mix(in srgb, var(--color-accent) clamp(0%, calc((0.21 + var(--dispatch-segment-border-delta, 0) + var(--dispatch-segment-intensity-border-boost, 0)) * 100%), 100%), transparent);
    --dispatch-legend-return-fill: color-mix(in srgb, var(--color-accent) clamp(0%, calc((0.11 + var(--dispatch-segment-fill-delta, 0) + var(--dispatch-segment-intensity-fill-boost, 0)) * 100%), 100%), transparent);

    /* Service stays dark on the left, independently of the lighter travel fill. */
    --dispatch-segment-loading-service-fill: color-mix(in srgb, rgb(var(--dispatch-segment-loading-rgb)) clamp(0%, calc((0.45 + var(--dispatch-segment-intensity-fill-boost, 0)) * 100%), 100%), var(--dispatch-segment-loading-tone));
    --dispatch-segment-delivery-service-fill: color-mix(in srgb, rgb(var(--dispatch-segment-delivery-rgb)) clamp(0%, calc((0.36 + var(--dispatch-segment-intensity-fill-boost, 0)) * 100%), 100%), var(--dispatch-segment-delivery-tone));
    --dispatch-segment-loading-service-overlay:
      linear-gradient(var(--dispatch-segment-loading-service-fill), var(--dispatch-segment-loading-service-fill));
    --dispatch-segment-delivery-service-overlay:
      linear-gradient(var(--dispatch-segment-delivery-service-fill), var(--dispatch-segment-delivery-service-fill));
    --dispatch-segment-inspection-service-shade: color-mix(in srgb, var(--color-accent) clamp(0%, calc((0.14 + var(--dispatch-segment-intensity-fill-boost, 0) * 0.55) * 100%), 100%), transparent);
    --dispatch-segment-inspection-service-overlay:
      linear-gradient(var(--dispatch-segment-inspection-service-shade), var(--dispatch-segment-inspection-service-shade));
    --dispatch-segment-return-service-shade: color-mix(in srgb, var(--color-accent) clamp(0%, calc((0.20 + var(--dispatch-segment-intensity-fill-boost, 0) * 0.55) * 100%), 100%), transparent);
    --dispatch-segment-return-service-overlay:
      linear-gradient(var(--dispatch-segment-return-service-shade), var(--dispatch-segment-return-service-shade));
    --dispatch-segment-neutral-service-overlay:
      linear-gradient(
        180deg,
        rgb(51 65 85 / clamp(0, calc(0.24 + var(--dispatch-segment-intensity-fill-boost, 0) * 0.55), 1)),
        rgb(51 65 85 / clamp(0, calc(0.14 + var(--dispatch-segment-intensity-fill-boost, 0) * 0.55), 1))
      );

    --dispatch-sequence-loading-marker-fill: var(--dispatch-segment-loading-service-fill);
    --dispatch-sequence-delivery-marker-fill: var(--dispatch-segment-delivery-service-fill);
    --dispatch-sequence-preload-marker-fill: color-mix(in srgb, rgb(122 143 184), #2f3f5c var(--dispatch-sequence-marker-darken-weight));
    --dispatch-sequence-return-marker-fill: var(--color-accent);
    --dispatch-sequence-icon-loading-border: var(--dispatch-segment-loading-border);
    --dispatch-sequence-icon-delivery-border: var(--dispatch-segment-delivery-border);
    --dispatch-sequence-badge-loading-fill: var(--dispatch-segment-loading-fill);
    --dispatch-sequence-badge-loading-border: var(--dispatch-segment-loading-border);
    --dispatch-sequence-badge-delivery-fill: var(--dispatch-segment-delivery-fill);
    --dispatch-sequence-badge-delivery-border: var(--dispatch-segment-delivery-border);
    --dispatch-sequence-badge-return-fill: color-mix(in srgb, var(--color-accent) clamp(0%, calc((0.14 + var(--dispatch-chip-fill-delta, 0) + var(--dispatch-segment-intensity-fill-boost, 0) * 0.55) * 100%), 100%), transparent);
    --dispatch-sequence-badge-return-border: color-mix(in srgb, var(--color-accent) clamp(0%, calc((0.16 + var(--dispatch-colored-border-delta, 0) + var(--dispatch-segment-intensity-border-boost, 0) * 0.45) * 100%), 100%), transparent);
    --dispatch-sequence-icon-return-mid: color-mix(in srgb, var(--color-accent) 80%, white);

    --dispatch-segment-loading-hover-border: var(--dispatch-segment-loading-border);
    --dispatch-segment-delivery-hover-border: var(--dispatch-segment-delivery-border);
    --dispatch-segment-return-hover-border: color-mix(in srgb, var(--color-accent) clamp(0%, calc((0.18 + var(--dispatch-colored-border-delta, 0)) * 100%), 100%), transparent);
    --dispatch-segment-preload-hover-border: rgb(122 143 184 / clamp(0, calc(0.28 + var(--dispatch-colored-border-delta, 0)), 1));
    /* Opaque detail surfaces share the segment palette, including portalled menus. */
    --dispatch-segment-loading-detail-fill: color-mix(in srgb, var(--dispatch-segment-loading-tone) 30%, white);
    --dispatch-segment-delivery-detail-fill: color-mix(in srgb, var(--dispatch-segment-delivery-tone) 30%, white);
    --dispatch-segment-return-detail-fill: color-mix(in srgb, var(--color-accent) clamp(0%, calc((0.08 + var(--dispatch-chrome-soft-darken-alpha, 0)) * 100%), 100%), white);
    --dispatch-segment-loading-hover-surface:
      linear-gradient(var(--dispatch-segment-loading-detail-fill), var(--dispatch-segment-loading-detail-fill));
    --dispatch-segment-delivery-hover-surface:
      linear-gradient(var(--dispatch-segment-delivery-detail-fill), var(--dispatch-segment-delivery-detail-fill));
    --dispatch-segment-return-hover-surface:
      linear-gradient(var(--dispatch-segment-return-detail-fill), var(--dispatch-segment-return-detail-fill));
    --dispatch-segment-preload-hover-surface:
      linear-gradient(rgb(122 143 184 / var(--dispatch-chrome-soft-darken-alpha, 0)), rgb(122 143 184 / var(--dispatch-chrome-soft-darken-alpha, 0))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-chrome-soft-lighten-alpha, 0)), rgb(255 255 255 / var(--dispatch-chrome-soft-lighten-alpha, 0))),
      linear-gradient(180deg, rgba(246, 248, 252, 0.998), rgba(234, 239, 248, 0.972));
    --dispatch-segment-loading-action-surface: var(--dispatch-segment-loading-hover-surface);
    --dispatch-segment-delivery-action-surface: var(--dispatch-segment-delivery-hover-surface);
    --dispatch-segment-return-action-surface: var(--dispatch-segment-return-hover-surface);

    --dispatch-sequence-loading-shadow: 0 0 0 1px var(--dispatch-segment-loading-border), 0 0 0 4px rgb(var(--dispatch-segment-loading-rgb) / clamp(0, calc(0.18 + var(--dispatch-segment-fill-delta, 0) + var(--dispatch-segment-intensity-fill-boost, 0)), 1)), 0 3px 8px rgba(15, 23, 42, 0.12);
    --dispatch-sequence-delivery-shadow: 0 0 0 1px var(--dispatch-segment-delivery-border), 0 0 0 4px rgb(var(--dispatch-segment-delivery-rgb) / clamp(0, calc(0.18 + var(--dispatch-segment-fill-delta, 0) + var(--dispatch-segment-intensity-fill-boost, 0)), 1)), 0 3px 8px rgba(15, 23, 42, 0.12);
    --dispatch-sequence-return-shadow: 0 0 0 1px color-mix(in srgb, var(--color-accent) clamp(0%, calc((0.26 + var(--dispatch-segment-border-delta, 0) + var(--dispatch-segment-intensity-border-boost, 0)) * 100%), 100%), transparent), 0 0 0 4px color-mix(in srgb, var(--color-accent) clamp(0%, calc((0.14 + var(--dispatch-segment-fill-delta, 0) + var(--dispatch-segment-intensity-fill-boost, 0)) * 100%), 100%), transparent), 0 3px 8px rgba(15, 23, 42, 0.12);
    --dispatch-sequence-preload-shadow: 0 0 0 1px rgb(88 106 145 / clamp(0, calc(0.34 + var(--dispatch-segment-border-delta, 0) + var(--dispatch-segment-intensity-border-boost, 0)), 1)), 0 0 0 4px rgb(122 143 184 / clamp(0, calc(0.18 + var(--dispatch-segment-fill-delta, 0) + var(--dispatch-segment-intensity-fill-boost, 0)), 1)), 0 3px 8px rgba(15, 23, 42, 0.12);

    --dispatch-card-success-accent: rgb(15 118 110 / clamp(0, calc(0.42 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-card-warning-accent: rgb(217 119 6 / clamp(0, calc(0.48 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-card-danger-accent: rgb(185 28 28 / clamp(0, calc(0.62 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-card-neutral-accent: rgb(148 163 184 / clamp(0, calc(0.28 + var(--dispatch-neutral-colored-border-delta)), 1));
    --dispatch-card-success-border: rgb(74 130 92 / clamp(0, calc(0.22 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-card-warning-border: rgb(217 119 6 / clamp(0, calc(0.18 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-card-danger-border: rgb(185 28 28 / clamp(0, calc(0.28 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-card-neutral-border: rgb(148 163 184 / clamp(0, calc(0.18 + var(--dispatch-neutral-colored-border-delta)), 1));
    --dispatch-card-warning-icon-border: rgb(217 119 6 / clamp(0, calc(0.15 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-card-danger-icon-border: rgb(185 28 28 / clamp(0, calc(0.26 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-card-neutral-icon-border: rgb(203 213 225 / clamp(0, calc(0.72 + var(--dispatch-neutral-colored-border-delta)), 1));
    --dispatch-card-success-surface:
      var(--dispatch-soft-overlay-success),
      linear-gradient(180deg, rgba(255, 255, 255, 0.99), rgba(247, 251, 248, 0.96));
    --dispatch-card-warning-surface:
      var(--dispatch-soft-overlay-warning),
      linear-gradient(180deg, rgba(255, 255, 255, 0.99), rgba(255, 250, 241, 0.96));
    --dispatch-card-danger-surface:
      var(--dispatch-soft-overlay-danger),
      linear-gradient(180deg, rgba(255, 255, 255, 0.99), rgba(254, 226, 226, 0.97));
    --dispatch-card-neutral-surface:
      var(--dispatch-soft-overlay-neutral),
      linear-gradient(180deg, rgba(255, 255, 255, 0.99), rgba(249, 250, 251, 0.96));
    --dispatch-card-success-icon:
      var(--dispatch-soft-overlay-success),
      linear-gradient(rgba(232, 242, 235, 0.92), rgba(232, 242, 235, 0.92));
    --dispatch-card-warning-icon:
      var(--dispatch-soft-overlay-warning),
      linear-gradient(rgba(255, 247, 224, 0.92), rgba(255, 247, 224, 0.92));
    --dispatch-card-danger-icon:
      var(--dispatch-soft-overlay-danger),
      linear-gradient(rgba(254, 226, 226, 0.96), rgba(254, 202, 202, 0.94));
    --dispatch-card-neutral-icon:
      var(--dispatch-soft-overlay-neutral),
      linear-gradient(rgba(240, 244, 241, 0.9), rgba(240, 244, 241, 0.9));
    --dispatch-card-danger-ink: color-mix(in srgb, #b91c1c, #7f1d1d var(--dispatch-chrome-chip-darken-weight));
    --dispatch-badge-danger-border: rgb(185 28 28 / clamp(0, calc(0.34 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-badge-danger-fill: color-mix(in srgb, color-mix(in srgb, rgba(254, 226, 226, 0.96), #b91c1c var(--dispatch-chrome-chip-darken-weight)), white var(--dispatch-chrome-chip-lighten-weight));
    --dispatch-badge-warning-border: rgb(217 119 6 / clamp(0, calc(0.30 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-badge-warning-fill: color-mix(in srgb, color-mix(in srgb, rgba(255, 237, 213, 0.96), #b45309 var(--dispatch-chrome-chip-darken-weight)), white var(--dispatch-chrome-chip-lighten-weight));
    --dispatch-tab-danger-fill: color-mix(in srgb, color-mix(in srgb, rgba(254, 226, 226, 0.96), #b91c1c var(--dispatch-chrome-chip-darken-weight)), white var(--dispatch-chrome-chip-lighten-weight));
    --dispatch-tab-danger-border: rgb(185 28 28 / clamp(0, calc(0.28 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-tab-danger-ink: color-mix(in srgb, #b91c1c, #7f1d1d var(--dispatch-chrome-chip-darken-weight));
    --dispatch-action-danger-border: rgb(185 28 28 / clamp(0, calc(0.30 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-action-danger-fill: color-mix(in srgb, color-mix(in srgb, rgba(254, 226, 226, 0.94), #b91c1c var(--dispatch-chrome-chip-darken-weight)), white var(--dispatch-chrome-chip-lighten-weight));
    --dispatch-action-danger-ink: color-mix(in srgb, #b91c1c, #7f1d1d var(--dispatch-chrome-chip-darken-weight));
    --dispatch-action-danger-hover-border: rgb(153 27 27 / clamp(0, calc(0.40 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-action-danger-hover-fill: color-mix(in srgb, color-mix(in srgb, rgba(254, 202, 202, 0.98), #991b1b var(--dispatch-chrome-chip-darken-weight)), white var(--dispatch-chrome-chip-lighten-weight));
    /* « Mise à jour » : rouge brique plein (bouton et en-têtes de son panneau). */
    --dispatch-update-fill: #9c3b31;
    --dispatch-update-hover-fill: #86322a;
    --dispatch-update-border: rgb(156 59 49 / 0.45);
    --dispatch-action-brand-border: rgb(15 92 87 / clamp(0, calc(0.30 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-action-brand-fill: var(--shell-optimizer-button);
    --dispatch-action-brand-ink: #ffffff;
    --dispatch-action-brand-hover-border: rgb(12 75 71 / clamp(0, calc(0.40 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-action-brand-hover-fill: var(--shell-optimizer-button-hover);
    --dispatch-card-brand-border: rgb(15 92 87 / clamp(0, calc(0.22 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-card-brand-surface: rgba(236, 253, 245, 0.52);
    --dispatch-badge-brand-border: rgb(255 255 255 / clamp(0, calc(0.42 + var(--dispatch-colored-border-delta, 0) * 0.004), 1));
    --dispatch-badge-brand-fill: rgb(255 255 255 / 0.94);
    --dispatch-card-brand-ink: var(--shell-optimizer-button);
    --dispatch-card-blocking-border: rgb(185 28 28 / clamp(0, calc(0.42 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-card-blocking-surface:
      var(--dispatch-soft-overlay-danger),
      linear-gradient(180deg, rgba(254, 226, 226, 0.98), rgba(255, 245, 244, 0.98));
    --dispatch-card-blocking-icon-border: rgb(185 28 28 / clamp(0, calc(0.46 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-card-blocking-icon-fill:
      var(--dispatch-soft-overlay-danger),
      linear-gradient(rgba(254, 226, 226, 0.98), rgba(254, 202, 202, 0.96));
    --dispatch-card-blocking-icon-ink: color-mix(in srgb, #b91c1c, #7f1d1d var(--dispatch-chrome-chip-darken-weight));
    --dispatch-card-blocking-ring: rgb(185 28 28 / clamp(0, calc(0.22 + var(--dispatch-colored-border-delta, 0) * 0.5), 1));

    --dispatch-status-warning-border: rgb(217 119 6 / clamp(0, calc(0.20 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-status-warning-fill: color-mix(in srgb, color-mix(in srgb, rgba(255, 247, 237, 0.96), rgb(217 119 6) var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --dispatch-status-success-border: rgb(15 118 110 / clamp(0, calc(0.18 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-status-success-fill: color-mix(in srgb, color-mix(in srgb, rgba(240, 253, 250, 0.98), rgb(15 118 110) var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --dispatch-status-neutral-border: rgb(148 163 184 / clamp(0, calc(0.22 + var(--dispatch-neutral-colored-border-delta)), 1));
    --dispatch-status-neutral-fill: color-mix(in srgb, color-mix(in srgb, rgba(248, 250, 252, 0.96), rgb(100 116 139) var(--dispatch-neutral-chip-darken-weight)), white var(--dispatch-neutral-chip-lighten-weight));
    --dispatch-day-trigger-border: rgb(203 213 225 / clamp(0.88, calc(0.88 + var(--dispatch-neutral-colored-border-delta, 0)), 1));
    --dispatch-day-trigger-surface: linear-gradient(180deg, #ffffff, #ffffff);
    --dispatch-day-icon-border: rgb(15 118 110 / clamp(0, calc(0.16 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-day-icon-surface:
      var(--dispatch-soft-overlay-success),
      linear-gradient(rgba(223, 243, 240, 0.94), rgba(223, 243, 240, 0.94));

    /* Hovercard metric pills: pastel at 0%, intensify via chrome chip alphas. */
    --dispatch-chip-compartment-surface:
      linear-gradient(rgb(57 86 126 / var(--dispatch-chrome-chip-darken-alpha, 0)), rgb(57 86 126 / var(--dispatch-chrome-chip-darken-alpha, 0))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-chrome-chip-lighten-alpha, 0)), rgb(255 255 255 / var(--dispatch-chrome-chip-lighten-alpha, 0))),
      linear-gradient(180deg, rgba(215, 225, 241, 0.98), rgba(198, 212, 234, 0.98));
    --dispatch-chip-occupancy-surface:
      linear-gradient(rgb(72 93 120 / var(--dispatch-chrome-chip-darken-alpha, 0)), rgb(72 93 120 / var(--dispatch-chrome-chip-darken-alpha, 0))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-chrome-chip-lighten-alpha, 0)), rgb(255 255 255 / var(--dispatch-chrome-chip-lighten-alpha, 0))),
      linear-gradient(180deg, rgba(231, 237, 244, 0.98), rgba(212, 221, 232, 0.98));
    --dispatch-chip-distance-surface:
      linear-gradient(rgb(49 70 60 / var(--dispatch-chrome-chip-darken-alpha, 0)), rgb(49 70 60 / var(--dispatch-chrome-chip-darken-alpha, 0))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-chrome-chip-lighten-alpha, 0)), rgb(255 255 255 / var(--dispatch-chrome-chip-lighten-alpha, 0))),
      linear-gradient(180deg, rgba(212, 224, 217, 0.98), rgba(195, 210, 202, 0.98));
    --dispatch-chip-duration-surface:
      linear-gradient(rgb(73 108 155 / var(--dispatch-chrome-chip-darken-alpha, 0)), rgb(73 108 155 / var(--dispatch-chrome-chip-darken-alpha, 0))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-chrome-chip-lighten-alpha, 0)), rgb(255 255 255 / var(--dispatch-chrome-chip-lighten-alpha, 0))),
      linear-gradient(180deg, rgba(221, 230, 244, 0.98), rgba(203, 217, 238, 0.98));
    --dispatch-chip-service-surface:
      linear-gradient(rgb(65 84 90 / var(--dispatch-chrome-chip-darken-alpha, 0)), rgb(65 84 90 / var(--dispatch-chrome-chip-darken-alpha, 0))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-chrome-chip-lighten-alpha, 0)), rgb(255 255 255 / var(--dispatch-chrome-chip-lighten-alpha, 0))),
      linear-gradient(180deg, rgba(225, 230, 233, 0.98), rgba(208, 215, 220, 0.98));
    --dispatch-chip-amber-surface:
      linear-gradient(rgb(180 83 9 / var(--dispatch-chrome-chip-darken-alpha, 0)), rgb(180 83 9 / var(--dispatch-chrome-chip-darken-alpha, 0))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-chrome-chip-lighten-alpha, 0)), rgb(255 255 255 / var(--dispatch-chrome-chip-lighten-alpha, 0))),
      linear-gradient(180deg, rgba(254, 243, 199, 0.98), rgba(253, 230, 138, 0.98));
    --dispatch-chip-orange-surface:
      linear-gradient(rgb(234 88 12 / var(--dispatch-chrome-chip-darken-alpha, 0)), rgb(234 88 12 / var(--dispatch-chrome-chip-darken-alpha, 0))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-chrome-chip-lighten-alpha, 0)), rgb(255 255 255 / var(--dispatch-chrome-chip-lighten-alpha, 0))),
      linear-gradient(180deg, rgba(255, 247, 237, 0.98), rgba(254, 215, 170, 0.98));
    --dispatch-chip-yellow-surface:
      linear-gradient(rgb(217 119 6 / var(--dispatch-chrome-chip-darken-alpha, 0)), rgb(217 119 6 / var(--dispatch-chrome-chip-darken-alpha, 0))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-chrome-chip-lighten-alpha, 0)), rgb(255 255 255 / var(--dispatch-chrome-chip-lighten-alpha, 0))),
      linear-gradient(180deg, rgba(255, 247, 237, 0.98), rgba(254, 240, 138, 0.98));
    --dispatch-chip-compartment-border: rgb(57 86 126 / clamp(0, calc(0.18 + var(--dispatch-color-intensity-percent, 0) * 0.004), 1));
    --dispatch-chip-occupancy-border: rgb(72 93 120 / clamp(0, calc(0.20 + var(--dispatch-color-intensity-percent, 0) * 0.004), 1));
    --dispatch-chip-distance-border: rgb(49 70 60 / clamp(0, calc(0.16 + var(--dispatch-color-intensity-percent, 0) * 0.004), 1));
    --dispatch-chip-duration-border: rgb(73 108 155 / clamp(0, calc(0.18 + var(--dispatch-color-intensity-percent, 0) * 0.004), 1));
    --dispatch-chip-service-border: rgb(65 84 90 / clamp(0, calc(0.16 + var(--dispatch-color-intensity-percent, 0) * 0.004), 1));
    --dispatch-chip-amber-border: rgb(180 83 9 / clamp(0, calc(0.22 + var(--dispatch-color-intensity-percent, 0) * 0.004), 1));
    --dispatch-chip-orange-border: rgb(234 88 12 / clamp(0, calc(0.24 + var(--dispatch-color-intensity-percent, 0) * 0.004), 1));
    --dispatch-chip-yellow-border: rgb(217 119 6 / clamp(0, calc(0.24 + var(--dispatch-color-intensity-percent, 0) * 0.004), 1));
    --dispatch-compartment-loading-fill: var(--dispatch-segment-loading-fill);
    --dispatch-compartment-loading-border: var(--dispatch-segment-loading-border);
    --dispatch-compartment-delivery-fill: var(--dispatch-segment-delivery-fill);
    --dispatch-compartment-delivery-border: var(--dispatch-segment-delivery-border);
    --dispatch-tab-warning-fill: color-mix(in srgb, color-mix(in srgb, rgba(250, 236, 211, 0.92), rgb(208 139 62) var(--dispatch-chrome-chip-darken-weight)), white var(--dispatch-chrome-chip-lighten-weight));
    --dispatch-tab-warning-border: rgb(208 139 62 / clamp(0, calc(0.18 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-tab-idle-fill: color-mix(in srgb, color-mix(in srgb, rgba(244, 247, 243, 0.74), rgb(59 71 68) var(--dispatch-neutral-chip-darken-weight)), white var(--dispatch-neutral-chip-lighten-weight));
    --dispatch-suspended-alt-border: rgb(148 163 184 / clamp(0, calc(0.18 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-suspended-alt-surface: var(--results-shell-periphery);
    --dispatch-suspended-info-border: rgb(56 99 142 / clamp(0, calc(0.18 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-suspended-info-surface:
      linear-gradient(rgb(56 99 142 / var(--dispatch-soft-darken-alpha)), rgb(56 99 142 / var(--dispatch-soft-darken-alpha))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-soft-lighten-alpha)), rgb(255 255 255 / var(--dispatch-soft-lighten-alpha))),
      linear-gradient(180deg, rgba(243, 248, 252, 0.98), rgba(255, 255, 255, 0.98));
    --dispatch-suspended-detail-border: rgb(148 163 184 / clamp(0, calc(0.10 + var(--dispatch-colored-border-delta, 0)), 1));
    --dispatch-suspended-detail-surface:
      linear-gradient(rgb(148 163 184 / calc(var(--dispatch-soft-darken-alpha) * 0.35)), rgb(148 163 184 / calc(var(--dispatch-soft-darken-alpha) * 0.35))),
      linear-gradient(rgb(255 255 255 / var(--dispatch-soft-lighten-alpha)), rgb(255 255 255 / var(--dispatch-soft-lighten-alpha))),
      linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(255, 255, 255, 0.99));
    --dispatch-suspended-quantity-fill: color-mix(in srgb, color-mix(in srgb, rgba(243, 248, 252, 0.96), rgb(56 99 142) var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));

    /* Crop/product pills remain global elsewhere; only Dispatch inherits these tunable surfaces. */
    --crop-default-bg: color-mix(in srgb, color-mix(in srgb, #f4f6fb, #56657d var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --crop-default-border: color-mix(in srgb, color-mix(in srgb, #d6dfec, #56657d var(--dispatch-colored-border-darken-weight)), white var(--dispatch-colored-border-lighten-weight));
    --crop-mais-bg: color-mix(in srgb, color-mix(in srgb, #eef2ff, #3730a3 var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --crop-mais-border: color-mix(in srgb, color-mix(in srgb, #c7d2fe, #3730a3 var(--dispatch-colored-border-darken-weight)), white var(--dispatch-colored-border-lighten-weight));
    --crop-ble-bg: color-mix(in srgb, color-mix(in srgb, #f6efe8, #7a5b3f var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --crop-ble-border: color-mix(in srgb, color-mix(in srgb, #e4d4c1, #7a5b3f var(--dispatch-colored-border-darken-weight)), white var(--dispatch-colored-border-lighten-weight));
    --crop-soya-bg: color-mix(in srgb, color-mix(in srgb, #e6f7fb, #0f6f8c var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --crop-soya-border: color-mix(in srgb, color-mix(in srgb, #bde4ee, #0f6f8c var(--dispatch-colored-border-darken-weight)), white var(--dispatch-colored-border-lighten-weight));
    --crop-orge-bg: color-mix(in srgb, color-mix(in srgb, #edf3f8, #45627a var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --crop-orge-border: color-mix(in srgb, color-mix(in srgb, #d1deea, #45627a var(--dispatch-colored-border-darken-weight)), white var(--dispatch-colored-border-lighten-weight));
    --crop-avoine-bg: color-mix(in srgb, color-mix(in srgb, #f3efff, #6b4fc3 var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --crop-avoine-border: color-mix(in srgb, color-mix(in srgb, #ddd1ff, #6b4fc3 var(--dispatch-colored-border-darken-weight)), white var(--dispatch-colored-border-lighten-weight));
    --crop-canola-bg: color-mix(in srgb, color-mix(in srgb, #fdebf3, #a13b67 var(--dispatch-chip-darken-weight)), white var(--dispatch-chip-lighten-weight));
    --crop-canola-border: color-mix(in srgb, color-mix(in srgb, #f5ccdc, #a13b67 var(--dispatch-colored-border-darken-weight)), white var(--dispatch-colored-border-lighten-weight));

    /* Keep delivery text contrast stable even when the user lightens the fill.
       Positive intensity also darkens inks so stronger fills stay readable. */
    --route-loading-ink: color-mix(in srgb, #31486f, #0f172a var(--dispatch-segment-ink-darken-weight));
    --route-loading-strong: color-mix(in srgb, #3f5585, #0f172a var(--dispatch-segment-ink-darken-weight));
    --route-delivery-strong: color-mix(in srgb, #595122, #1c1917 var(--dispatch-segment-ink-darken-weight));
    --color-legacy-teal: var(--color-accent);
    --color-legacy-teal-strong: var(--color-accent-strong);
    --dispatch-segment-preload-ink: color-mix(in srgb, #3f5278, #0f172a var(--dispatch-segment-ink-darken-weight));
    background: var(--panel);
  }

  .dispatch-product-tone-generated {
    color: var(--dispatch-product-generated-accent);
    background-color: color-mix(
      in srgb,
      color-mix(
        in srgb,
        color-mix(in srgb, white 84%, var(--dispatch-product-generated-accent)),
        var(--dispatch-product-generated-accent) var(--dispatch-chip-darken-weight, 0%)
      ),
      white var(--dispatch-chip-lighten-weight, 0%)
    );
    border-color: color-mix(
      in srgb,
      color-mix(
        in srgb,
        color-mix(in srgb, white 68%, var(--dispatch-product-generated-accent)),
        var(--dispatch-product-generated-accent) var(--dispatch-colored-border-darken-weight, 0%)
      ),
      white var(--dispatch-colored-border-lighten-weight, 0%)
    );
  }

  .dispatch-product-tone-fixed {
    color: var(--dispatch-product-fixed-text);
    background-color: color-mix(
      in srgb,
      color-mix(
        in srgb,
        var(--dispatch-product-fixed-bg),
        var(--dispatch-product-fixed-text) var(--dispatch-chip-darken-weight, 0%)
      ),
      white var(--dispatch-chip-lighten-weight, 0%)
    );
    border-color: color-mix(
      in srgb,
      color-mix(
        in srgb,
        var(--dispatch-product-fixed-border),
        var(--dispatch-product-fixed-text) var(--dispatch-colored-border-darken-weight, 0%)
      ),
      white var(--dispatch-colored-border-lighten-weight, 0%)
    );
  }

  body.results-page.results-evening-session {
    --results-shell-main: #eceef2;
    --results-shell-outer: #f3f4f6;
    --results-shell-periphery:
      linear-gradient(180deg, rgba(42, 51, 58, 0.06), rgba(76, 85, 92, 0.04)),
      #e5e8ec;
    --results-shell-nav:
      linear-gradient(180deg, rgba(33, 42, 50, 0.08), rgba(77, 87, 94, 0.05)),
      #eef0f3;
    background:
      linear-gradient(180deg, rgba(32, 39, 46, 0.10), rgba(77, 86, 94, 0.08)),
      var(--results-shell-outer);
  }

  [data-results-analysis-stage-root="true"][data-active-view] {
    display: grid;
  }

  [data-results-analysis-stage-root="true"][data-active-view="suspended"] [data-detail-panel="suspended"],
  [data-results-analysis-stage-root="true"][data-active-view="errors"] [data-detail-panel="errors"] {
    display: block;
  }
}

[data-results-fleet-column-root="true"] [data-assignment-card] {
  position: relative;
}

/*
 * Encadrés Route (panneaux latéraux, KPI, séquence) : 4px, comme Vue flotte.
 * Pastilles : 4px (règle #results-board .pill ci-dessous).
 */
#results-board [data-results-fleet-column-root="true"] > div,
#results-board [data-results-route-steps-root="true"] > section,
#results-board [data-results-fleet-column-root="true"] [data-results-fleet-dock-panel="true"],
#results-board [data-metric-card="true"],
#results-board [data-route-sequence-panel="true"] {
  border-radius: 4px !important;
}

/*
 * Force le rayon « pastille » hors @layer Tailwind.
 * Sur les petites pastilles, 8px ≈ capsule ; 4px = standard visuel des KPI Route.
 */
#results-board .pill,
#results-board [data-status-badge],
#results-board [data-route-pill],
#results-board [data-route-action],
#results-board [data-assignment-status],
#results-board [data-assignment-dispatch-disabled],
#results-board [data-assignment-manual-mix],
#results-board [data-assignment-manual-mix-product],
#results-board [data-assignment-grain-type],
#results-board [data-assignment-step-product],
#results-board [data-assignment-step-manual-status],
#results-board [data-route-target-stop-summary],
#results-board [data-route-target-trip-load] {
  border-radius: 4px !important;
}

/* Hors @layer pour primer sur les utilitaires Tailwind du Gantt soir. */
body.results-page.results-evening-session [data-fleet-timeline-panel="true"] {
  border: 2px solid #000 !important;
  border-radius: 20px;
}

body.results-page.results-evening-session [data-fleet-timeline-panel="true"] [data-fleet-timeline-rows-canvas="true"] {
  background: linear-gradient(
    180deg,
    rgba(58, 68, 80, 0.96),
    rgba(48, 57, 68, 0.98)
  ) !important;
  border-radius: 14px;
  padding: 0.375rem;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

/*
 * Un contrôle indisponible reste neutre, quelle que soit la couleur de son
 * action lorsqu'elle est disponible. Le layer base et !important priment sur
 * les utilitaires de ton Tailwind, y compris leurs variantes forcées.
 */
@layer base {
  button:disabled:not(:where([role="menu"] *, [role="menuitem"], [data-button-visual-scope="menu"] *)),
  button[aria-disabled="true"]:not(:where([role="menu"] *, [role="menuitem"], [data-button-visual-scope="menu"] *)),
  [role="button"][aria-disabled="true"]:not(:where([role="menu"] *, [role="menuitem"], [data-button-visual-scope="menu"] *)),
  a[aria-disabled="true"]:not(:where([role="menu"] *, [role="menuitem"], [data-button-visual-scope="menu"] *)) {
    background-color: var(--color-slate-50, #f8fafc) !important;
    background-image: none !important;
    border-color: var(--color-slate-200, #e2e8f0) !important;
    color: var(--color-slate-400, #94a3b8) !important;
    box-shadow: none !important;
    cursor: not-allowed !important;
    opacity: 1 !important;
    transform: none !important;
  }
}

/* Shared top banner (truck) across workspace sections. */
.workspace-truck-banner > div:first-child::before,
.data-manager-hero::before,
.import-files-page .import-hero::before,
.reports-page .reports-hero::before,
.system-config-page .system-config-hero::before,
.dashboard-hero::before {
  width: 46% !important;
  max-width: 620px !important;
  background-size: cover !important;
  background-position: right center !important;
  mask-image: linear-gradient(90deg, transparent 0%, rgb(0 0 0 / 0.06) 8%, rgb(0 0 0 / 0.25) 20%, rgb(0 0 0 / 0.6) 34%, rgb(0 0 0 / 0.9) 46%, black 55%) !important;
}

/*
 * Consolidation : chaque gris de texte fonce d'un cran pour la lecture.
 * :where garde la spécificité d'une classe simple : hover:, disabled: et les autres variantes l'emportent toujours.
 */
@layer utilities {
  .consolidation-readable :where(.text-slate-400) { color: var(--color-slate-600); }
  .consolidation-readable :where(.text-slate-500) { color: var(--color-slate-700); }
  .consolidation-readable :where(.text-slate-600) { color: var(--color-slate-800); }
  .consolidation-readable :where(.text-slate-700) { color: var(--color-slate-900); }
  .consolidation-readable :where(input, textarea)::placeholder { color: var(--color-slate-600); }
}

/* Consolidation et Facturation : fond gris moyen ; l'en-tête, les cartes et les tableaux se détachent en blanc. */
.bg-surface-results:has(main.consolidation-readable, .billing-page) { background: #d9e0e8; }

/* Consolidation : cadre de l'arrêt, nom du client inclus ; rouge si tout est non livré, vert au survol sinon. */
tbody[data-stop-excluded] { --stop-frame-color: #b23b35; }
tbody:is([data-stop-active], [data-stop-excluded]) > tr > td {
  box-shadow: inset 0 calc(var(--frame-top, 0) * 2px) 0 var(--stop-frame-color, var(--color-accent)), inset 0 calc(var(--frame-bottom, 0) * -2px) 0 var(--stop-frame-color, var(--color-accent)),
    inset calc(var(--frame-left, 0) * 4px) 0 0 var(--stop-frame-color, var(--color-accent)), inset calc(var(--frame-right, 0) * -2px) 0 0 var(--stop-frame-color, var(--color-accent));
}
tbody:is([data-stop-active], [data-stop-excluded]) > tr:first-child > td { --frame-top: 1; }
tbody:is([data-stop-active], [data-stop-excluded]) > tr:last-child > td { --frame-bottom: 1; }
tbody:is([data-stop-active], [data-stop-excluded]) > tr > td:first-child { --frame-left: 1; }
tbody:is([data-stop-active], [data-stop-excluded]) > tr > td:last-child { --frame-right: 1; }
